import { coreRoutes } from "./core.routes";
import { settingsRoutes } from "./settings.routes";
import { trialRoutes } from "./trials.routes";
import { committeeRoutes } from "./committees.routes";
import { groupRoutes } from "./groups.routes";
import { personnelRoutes } from "./personnel.routes";
import { projectRoutes } from "./projects.routes";
import { institutionRoutes } from "./institutions.routes";
import { laboratoryRoutes } from "./laboratories.routes";
import type { AppRouteObject } from "./types";
import { withRouteMetadata } from "./metadata";

/**
 * The child route registry is shared by the router and the application shell.
 * Keeping one registry prevents the header from maintaining a second list of
 * destinations that can drift from the actual route tree.
 */
export const appRouteChildren: AppRouteObject[] = [
    ...coreRoutes,
    settingsRoutes,
    trialRoutes,
    committeeRoutes,
    groupRoutes,
    personnelRoutes,
    projectRoutes,
    institutionRoutes,
    laboratoryRoutes,
];

/** The one decorated route tree used by the router and route metadata runtime. */
export const decoratedAppRouteChildren = withRouteMetadata(appRouteChildren, 1);
